export default "__VITE_PUBLIC_ASSET__2f56ab5a__"